import type { FC } from "react";
import { cn } from "../../utils";

const borderClasses = "border-4 border-solid";

type Props = {
  color: string;
  delay: string;
};

const LoaderRing: FC<Props> = ({ color, delay }) => (
  <div
    className={cn(
      borderClasses,
      color,
      "absolute w-full h-full rounded-full animate-[spin_1.2s_cubic-bezier(0.5,0,0.5,1)_infinite] border-x-transparent border-b-transparent",
    )}
    style={{ animationDelay: delay }}
    role="presentation"
  />
);

export default LoaderRing;
